<mat-form-field class="general-margin" subscriptSizing="dynamic">
  <input  matInput type="text" value="" placeholder="{{'SEARCH' | translate}}" #input>
  <button matSuffix mat-icon-button (click)="onSearchClicked(input.value)" class="search-button">
    <mat-icon>search</mat-icon>
  </button>
</mat-form-field>
